<div class="header">
  <h3>ดาวน์โหลดเอกสาร</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row align-items-center">
    <div class="col-md-6 form-group">
      <div class="form-label-group">
        <input class="form-control" type="text" id="buyerName" [(ngModel)]="buyerName" placeholder="ชื่อ">
        <label for="searchText">ชื่อ</label>
      </div>
    </div>
    <div class="col-md-6 form-group">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="documentNumber" placeholder="เลขที่เอกสาร">
        <label for="month">เลขที่เอกสาร</label>
      </div>
    </div>
    <div class="col-md-6 form-group">
      <div class="form-label-group">
        <input class="form-control" type="text" id="email" [(ngModel)]="email" placeholder="อีเมล์">
        <label for="searchText">อีเมล์</label>
      </div>
    </div>
    <div class="col-md-6 form-group">
      <div class="dropdown m-t-10" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
            placeholder="วันที่" readonly>
          <label for="calendarDropdown">วันที่ยื่นคำร้อง</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">ตั้งแต่</div>
            <div class="col" style="padding-left: 30px">ถึง</div>
          </div>
          <div (click)="$event.stopPropagation()">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
              readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
              [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true" [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
              readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
              [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true" [locale]="calendarLocale">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <div class="row">
    <div class="col-md-6">
      <app-custom-pagination [(currentPage)]="currentPage" [(itemsPerPage)]="itemsPerPage" [totalItems]="totalItems"
        (pageChange)="pageChanged()" (optionChange)="optionChanged()">
      </app-custom-pagination>
    </div>
    <div class="col-md-6 text-right">
      <button type="button" class="btn btn-dv btn-wide" [disabled]="!approvedList.length"
        (click)="open(confirmModal)">อนุมัติ</button>
    </div>
  </div>

  <div class="scrollable m-t-30">
    <table class="table text-center" *ngIf="!loading">
      <thead>
        <tr>
          <th scope="col">ลำดับ</th>
          <th scope="col">ชื่อ</th>
          <th scope="col">เลขที่เอกสาร</th>
          <th scope="col">อีเมล์</th>
          <th scope="col">วันที่เอกสาร</th>
          <th>
            <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="isCheckAll" (click)="checkAll()"></p-checkbox>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let document of documentList; let index = index">
          <td>{{ index + 1 }}</td>
          <td>{{ document.buyer_name || '-' }}</td>
          <td>{{ document.document_number || '-' }}</td>
          <td>{{ document.email }}</td>
          <td>{{ document.document_start_date }} ถึง {{ document.document_end_date }}</td>
          <td>
            <p-checkbox class="dv-checkbox" [(ngModel)]="document.status" binary="true"
              (onChange)="toggleStatusChange()"></p-checkbox>
            <!-- <a href="javascript:void(0)" (click)="deleteDownloadRequest(document.id)">
              <i class="fa fa-trash"></i>
            </a> -->
          </td>
        </tr>
        <tr *ngIf="!documentList.length">
          <td colspan="6" class="text-center">ไม่พบคำร้อง</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #confirmModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="d('')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!showResults; else completed">
      ยืนยันการอนุมัติคำร้อง จำนวน {{ approvedList.length }} รายการ ?
    </div>
    <ng-template #completed>
      <div *ngIf="successEmailList.length">
        <p>ส่งอีเมล์สำเร็จ</p>
        <ul>
          <li *ngFor="let email of successEmailList">{{ email }}</li>
        </ul>
      </div>
      <div *ngIf="failedEmailList.length">
        <p>ส่งล้มเหลว</p>
        <ul>
          <li *ngFor="let email of failedEmailList">{{ email }}</li>
        </ul>
      </div>
    </ng-template>
  </div>
  <div class="modal-footer" *ngIf="!showResults">
    <button type="button" class="btn btn-dv btn-wide" (click)="confirm()">
      <i *ngIf="isLoadingConfirm === true" class="fa fa-spinner fa-spin m-r-5"></i>
      <i *ngIf="isLoadingConfirm === false" class="fa fa-check m-r-5"></i>
      ยืนยัน
    </button>
  </div>
</ng-template>


// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-list/download-list.component.html